<button class="accent transparent" mat-flat-button appStopPropagation (click)="preview()">
  {{ 'button.preview' | translate }}
</button>
